export default "__VITE_ASSET__a57176a5__"